import { 
    getEditHouseGroupList,
    editHouseGroup
    } from "@/apis/company/houseGroup.js"; 
import router from '@/router'
/* 
  這邊可以改為用 types 物件取代 matutions_type.js (繼續用也可以)
  然後在前面加上模組名稱作為前綴，用來避免與其他模組重複。
  因為 action、mutation、和 getter 依然是註冊在全域的命名空間
*/
const types = {
    set_edit_house_group_list: 'bizEditHouseGroupMgt/set_edit_house_group_list',
    set_filter_word: 'bizEditHouseGroupMgt/set_filter_word',
    set_checkbox_status: 'bizEditHouseGroupMgt/set_checkbox_status',
    set_selected_house: 'bizEditHouseGroupMgt/set_selected_house',
    set_filter_query: 'bizEditHouseGroupMgt/set_filter_query',
    set_success_list: 'bizEditHouseGroupMgt/set_success_list',
    set_house_group_id: 'bizEditHouseGroupMgt/set_house_group_id',
}

// count state 必須是 Object
const state = {
    houseGroupId: null,
    editHouseGroupList: [],
    checkboxStatus: {
        checkboxAll: false,
    },
    selectedHouse: [],
    filterQuery: {},
    filterQueryUpdate: 0,
    successList: []
}

// getters 也可以整理到這邊直接返回 count 內容
const getters = {
    GET_BIZ_EDIT_HOUSE_GROUP_MGT_LIST: (state) => {
        return state.editHouseGroupList
    },
    GET_BIZ_EDIT_HOUSE_GROUP_MGT_SUCCESS_LIST: (state) => {
        return state.successList
    },
    GET_BIZ_EDIT_HOUSE_GROUP_MGT_LIST_TOTAL: (state) => {
        return state.bizBatchPublishList.length
    },
    GET_BIZ_EDIT_HOUSE_GROUP_MGT_CHECKBOX_STATUS: (state) => {
        return state.checkboxStatus
    },
    GET_BIZ_EDIT_HOUSE_GROUP_MGT_HAS_SELECTED_HOUSE: (state) => {
        return state.selectedHouse.length?true:false
    },
    GET_BIZ_EDIT_HOUSE_GROUP_MGT_SELECTED_HOUSE_CID: (state) => {
        return state.selectedHouse
    },
    GET_BIZ_EDIT_HOUSE_GROUP_MGT_FILTER_QUERY: (state) => {
        return state.filterQuery
    },
    GET_BIZ_EDIT_HOUSE_GROUP_MGT_FILTER_QUERY_UPDATE: (state) => {
        return state.filterQueryUpdate
    },
    GET_BIZ_EDIT_HOUSE_GROUP_MGT_TOTAL: (state) => {
        return state.editHouseGroupList.length
    },
}

// actions 也是以 Object 形式建構。
const actions = {
    getBizEditHouseGroupList ( {commit, state} ) {
        let params = {
            houseGroupId: state.houseGroupId
        }
        return new Promise((resolve, reject) => {
            getEditHouseGroupList(params)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    commit(types.set_edit_house_group_list, res.data.result);
                    resolve()
                }
            })
            .catch(err => {
                reject(err)
            })
            
        })
    },
    editBizHouseGroup ( {dispatch, state}, obj ) {
        return new Promise((resolve, reject) => {
            if(obj.data.editType === 'MULTIPLE' && !obj.data.houses){
                obj.data.houses = state.selectedHouse
            }
            editHouseGroup(obj.data)
            .then(res => {
                if( res.data.status == "SUCCESS" ){
                    dispatch('getBizEditHouseGroupList')
                    resolve()
                }else{
                    dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg,type: 'error'})
                }
                resolve()
            })
            .catch(err => {
                dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg,type: 'error'})
                reject(err)
            })
            
        })
    },
    setBizEditHouseGroupCheckboxStatus ( {commit}, data ) {
        commit(types.set_checkbox_status, data)
    },
    setBizEditHouseGroupSeletedHouse ( {commit}, data ) {
        commit(types.set_selected_house, data)
    },
    setBizEditHouseGroupFilterQuery ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            commit(types.set_filter_query, value);
            resolve()
        })
    },
    setBizEditHouseGroupId ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            commit(types.set_house_group_id, value);
            resolve()
        })
    },
}

// mutations
const mutations = {
    [types.set_checkbox_status](state, data){
        state.checkboxStatus = data
    },
    [types.set_selected_house](state, data){
        state.selectedHouse = data
    },
    [types.set_success_list](state){
        state.successList = state.selectedHouse
    },
    [types.set_edit_house_group_list](state, data){
        state.editHouseGroupList = data
    },
    [types.set_filter_query](state, data){
        state.filterQuery = data
        state.filterQueryUpdate += 1
    },
    [types.set_house_group_id](state, data){
        state.houseGroupId = data
    },
}

/*
因為我們把 vuex 所有職權都寫在同一隻檔案，
所以必須要 export 出去給最外層 index.js 組合使用
*/
export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/bussiness/mgtCategory/houseGroupMgt/editHouseGroup.js